import {
    Theme,
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
} from '@mui/material';

interface M3Tooltip {
    MuiTooltip: {
        defaultProps?: ComponentsProps['MuiTooltip'];
        styleOverrides?: ComponentsOverrides<Theme>['MuiTooltip'];
        variants?: ComponentsVariants['MuiTooltip'];
    };
}

export const getTooltip = (theme: Theme): M3Tooltip => {
    const { palette } = theme;
    return {
        MuiTooltip: {
            defaultProps: {
                placement: 'top',
            },
            styleOverrides: {
                tooltip: {
                    borderRadius: 12,
                    paddingTop: 12,
                    paddingBottom: 8,
                    paddingLeft: 16,
                    paddingRight: 16,
                    boxShadow: theme.shadows[2],
                    background: palette.surfaceContainer.main,
                    color: palette.onSurfaceVariant.main,
                },
            },
        },
    };
};
